import { Skeleton } from "@mui/material";

const ROW_COUNT = 5;

const shellStyle = {
    width: "100%",
    background: "#fff",
    border: "1.5px solid #e1e4ea",
    borderRadius: "10px",
    overflow: "hidden",
};

const headStyle = {
    display: "flex",
    alignItems: "center",
    gap: "24px",
    padding: "14px 20px",
    background: "#f5f6f8",
    borderBottom: "1.5px solid #e1e4ea",
};

const rowStyle = {
    display: "flex",
    alignItems: "center",
    gap: "24px",
    padding: "18px 20px",
    borderBottom: "1px solid #e1e4ea",
};

const lastRowStyle = { ...rowStyle, borderBottom: "none" };

export const MyBookingLoader = () => {
    return (
        <div style={shellStyle}>
            {/* Header row skeleton — hidden on small screens */}
            <div style={headStyle} className="TableLoaderHead">
                <Skeleton animation="wave" width="16%" height={14} />
                <Skeleton animation="wave" width="20%" height={14} />
                <Skeleton animation="wave" width="12%" height={14} />
                <Skeleton animation="wave" width="10%" height={14} />
                <Skeleton animation="wave" width="10%" height={14} />
            </div>

            {Array.from({ length: ROW_COUNT }).map((_, index) => (
                <div key={index} style={index === ROW_COUNT - 1 ? lastRowStyle : rowStyle}>
                    <div style={{ width: "16%", minWidth: "110px" }}>
                        <Skeleton animation="wave" width="70%" height={20} />
                        <Skeleton animation="wave" width="45%" height={16} sx={{ mt: 0.5 }} />
                    </div>

                    <div style={{ width: "20%", minWidth: "120px", display: "flex", alignItems: "center", gap: 10 }}>
                        <Skeleton animation="wave" variant="rounded" width={56} height={5} />
                        <Skeleton animation="wave" width="60%" height={16} />
                    </div>

                    <div style={{ width: "12%", minWidth: "80px" }}>
                        <Skeleton animation="wave" width="80%" height={16} />
                    </div>

                    <div style={{ width: "10%", minWidth: "60px" }}>
                        <Skeleton animation="wave" width="70%" height={16} />
                    </div>

                    <div style={{ width: "10%", minWidth: "60px" }}>
                        <Skeleton animation="wave" width="70%" height={16} />
                    </div>

                    <div style={{ marginLeft: "auto" }}>
                        <Skeleton animation="wave" variant="circular" width={18} height={18} />
                    </div>
                </div>
            ))}

            <style>{`
        @media (max-width: 900px) {
          .TableLoaderHead { display: none !important; }
        }
      `}</style>
        </div>
    );
}

// Matches referralhistories' actual grid: 1.6fr Referred user | 1fr Status | 1fr Amount | 1fr Used amount
export const ReferralLoader = () => {
    return (
        <div style={shellStyle}>
            <div style={headStyle} className="ReferralLoaderHead">
                <Skeleton animation="wave" width="26%" height={14} />
                <Skeleton animation="wave" width="16%" height={14} />
                <Skeleton animation="wave" width="16%" height={14} />
                <Skeleton animation="wave" width="16%" height={14} />
            </div>

            {Array.from({ length: ROW_COUNT }).map((_, index) => (
                <div
                    key={index}
                    style={index === ROW_COUNT - 1 ? lastRowStyle : rowStyle}
                    className="ReferralLoaderRow"
                >
                    <div style={{ width: "28%", minWidth: "120px" }}>
                        <Skeleton animation="wave" width="75%" height={18} />
                    </div>

                    <div style={{ width: "16%", minWidth: "80px" }}>
                        <Skeleton animation="wave" variant="rounded" width={64} height={20} sx={{ borderRadius: "4px" }} />
                    </div>

                    <div style={{ width: "16%", minWidth: "70px" }}>
                        <Skeleton animation="wave" width="60%" height={16} />
                    </div>

                    <div style={{ width: "16%", minWidth: "70px" }}>
                        <Skeleton animation="wave" width="60%" height={16} />
                    </div>
                </div>
            ))}

            <style>{`
        @media (max-width: 767px) {
          .ReferralLoaderHead { display: none !important; }
          .ReferralLoaderRow { flex-direction: column; align-items: flex-start; gap: 8px; }
          .ReferralLoaderRow > div { width: 100% !important; }
        }
      `}</style>
        </div>
    );
}